import '../css/ProjectCard.css'

const ProjectCard = (props) => {
  return (
    <div className="card-content">
      <img src={props.img} alt="" />
      <h2>{props.name}</h2>
      <div>
        <p>
          <b>Key words:&nbsp;</b>
          {props.keyword}
        </p>
      </div>
    </div>
  )
}

export default ProjectCard
